/** Public quick-reply variables. Labels are translated; saved tokens stay stable. */
export const SNIPPET_VARIABLES = ["name", "phone", "email", "attendant", "channel"] as const;
export type SnippetContext = Partial<Record<(typeof SNIPPET_VARIABLES)[number], string | null>>;

const aliases: Record<string, keyof SnippetContext> = {
	nome: "name",
	"contato.nome": "name",
	"contact.name": "name",
	telefone: "phone",
	"contato.telefone": "phone",
	"contact.phone": "phone",
	"contato.email": "email",
	"contact.email": "email",
	atendente: "attendant",
	"atendente.nome": "attendant",
	canal: "channel",
	"canal.nome": "channel",
};

export function fillSnippet(text: string, context: SnippetContext): string {
	return text.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (whole, token: string) => {
		const key =
			SNIPPET_VARIABLES.find((name) => name === token) ??
			Object.entries(aliases).find(([alias]) => alias === token)?.[1];
		const value = key ? context[key] : null;
		return typeof value === "string" && value.trim() ? value : whole;
	});
}

export function missingSnippetVariables(text: string): string[] {
	return [
		...new Set([...text.matchAll(/\{\{([^{}]+)\}\}/g)].map((match) => match[1]?.trim() ?? "")),
	];
}
